/* eslint-disable */
export default {
  mainDataHeader: {
    analysis: {
      icon: "PieChartIcon",
      title: "Analysis",
      subtitle: "Choose what you would like to analyse."
    },
    "requests-analysis": {
      icon: "PieChartIcon",
      title: "Requests Analysis",
      subtitle: "Live numbers across all sources."
    },
    "users-analysis": {
      icon: "PieChartIcon",
      title: "Users Analysis",
      subtitle: "Live numbers across all sources."
    }
  }
};
